import { render, staticRenderFns } from "./notif.vue?vue&type=template&id=0a1ebd47&scoped=true&"
import script from "./notif.vue?vue&type=script&lang=js&"
export * from "./notif.vue?vue&type=script&lang=js&"
import style0 from "./notif.vue?vue&type=style&index=0&id=0a1ebd47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ebd47",
  null
  
)

export default component.exports